<template>
  <div class="container p-4">
    <div class="mb-4">
      <h2>If you or anyone you know needs help:</h2>
      <ul class="list-disc list-inside">
        <li><a href="http://www.lifeline.org.au/">Lifeline </a>on 13 11 14</li>
        <li>
          <a href="http://www.kidshelp.com.au/">Kids Helpline </a>on 1800 551
          800
        </li>
        <li>
          <a href="http://www.mensline.org.au/Home.html">MensLine Australia </a
          >on 1300 789 978
        </li>
        <li>
          <a href="http://www.suicidecallbackservice.org.au/"
            >Suicide Call Back Service </a
          >on 1300 659 467
        </li>
        <li>
          <a href="https://www.beyondblue.org.au/" target="_self" title=""
            >Beyond Blue</a
          >
          on 1300 224 636
        </li>
        <li>
          <a href="https://headspace.org.au/" target="_self" title=""
            >Headspace</a
          >
          on 1800 650 890
        </li>
        <li>
          <a href="https://au.reachout.com/" target="_self" title=""
            >ReachOut</a
          >
          at
          <a href="https://au.reachout.com/" target="_self" title=""
            >au.reachout.com</a
          >
        </li>
        <li>
          <a href="https://clan.org.au/about/" target="_self" title=""
            >Care Leavers Australasia Network (CLAN)</a
          >
          on 1800 008 774
        </li>
      </ul>
    </div>
    <p>
      There are currently
      <span class="font-bold">{{ remoteTracks.length }}</span> other people in
      this chat.
    </p>
    <AudioTrack
      v-for="track in remoteTracks"
      :key="track.id"
      :track="track.track"
    />
    <button
      v-if="muted"
      type="button"
      class="rounded-full py-1 px-4 border-2 border-green-500 focus:outline-none"
      @click="localTrack.unmute()"
    >
      Unmute
    </button>
    <button
      v-else
      type="button"
      class="rounded-full py-1 px-4 border-2 border-red-500 focus:outline-none"
      @click="localTrack.mute()"
    >
      Mute
    </button>
  </div>
</template>

<script>
import AudioEffect from "../AudioEffect";
import AudioTrack from "../components/AudioTrack";

const initOptions = {
  disableAudioLevels: true,
  desktopSharingChromeDisabled: true,
  disableSimulcast: false,
  enableRemb: true,
  enableTcc: true,
  enableP2P: false,
  desktopSharingFirefoxDisabled: true
};

const connectOptions = {
  hosts: {
    domain: "meet.jit.si",
    muc: "conference.meet.jit.si" // FIXME: use XEP-0030
  },
  bosh: "https://meet.jit.si/http-bind",
  websocket: "wss://meet.jit.si/xmpp-websocket",
  disableSimulcast: false,
  enableRemb: true,
  enableTcc: true,
  enableP2P: false,
  externalConnectUrl: "//meet.jit.si/http-pre-bind",

  // The name of client node advertised in XEP-0115 'c' stanza
  clientNode: "https://jitsi.org/jitsimeet"
};

const confOptions = {
  openBridgeChannel: true
};

export default {
  name: "Home",
  components: {
    AudioTrack
  },
  data() {
    return {
      connection: null,
      localTrack: null,
      room: null,
      remoteTracks: [],
      muted: false,
      devices: []
    };
  },
  async mounted() {
    window.addEventListener("unload", this.beforeDestroy);
    window.addEventListener("beforeunload", this.beforeDestroy);

    JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);
    JitsiMeetJS.init(initOptions);
    [this.localTrack] = (
      await JitsiMeetJS.createLocalTracks({ devices: ["audio"] })
    ).filter(track => track.isAudioTrack());

    this.connection = new JitsiMeetJS.JitsiConnection(
      null,
      null,
      connectOptions
    );

    this.connection.addEventListener(
      JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED,
      this.connected
    );

    this.connection.connect();
  },
  beforeDestroy() {
    this.beforeDestroy();
  },
  watch: {
    localTrack(local, old) {
      if (old) {
        old.detach(this.$refs.audioPlayer);
        old.removeEventListener(
          JitsiMeetJS.events.track.TRACK_MUTE_CHANGED,
          this.muteChanged
        );
        old.dispose();
      }

      local.setEffect(new AudioEffect());
      local.addEventListener(
        JitsiMeetJS.events.track.TRACK_MUTE_CHANGED,
        this.muteChanged
      );
    }
  },
  methods: {
    beforeDestroy() {
      if (this.localTrack) {
        this.localTrack.dispose();
      }
      if (this.room) {
        this.room.leave();
      }
      if (this.connection) {
        this.connection.disconnect();
      }
    },
    connected() {
      this.room = this.connection.initJitsiConference(
        "simontestingathing",
        confOptions
      );
      this.room.on(JitsiMeetJS.events.conference.CONFERENCE_JOINED, () =>
        this.room.addTrack(this.localTrack)
      );
      this.room.on(JitsiMeetJS.events.conference.TRACK_ADDED, this.addTrack);
      this.room.on(
        JitsiMeetJS.events.conference.TRACK_REMOVED,
        this.removeTrack
      );
      this.room.join();
    },
    addTrack(track) {
      if (track.isLocal() || track.getType() !== "audio") {
        return;
      }

      this.remoteTracks.push({ track: track, id: track.getId() });
    },
    removeTrack(track) {
      const idx = this.remoteTracks.findIndex(t => t.id === track.getId());

      if (idx === -1) {
        return;
      }

      this.remoteTracks.splice(idx, 1);
    },
    muteChanged(track) {
      this.muted = track.isMuted();
    }
  }
};
</script>
